import React from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import ReactHtmlParser from 'react-html-parser'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import { renderIndexItemClass } from 'helpers/tools'
import ContentBlock from 'components/atoms/ContentBlock'
import Typography from 'components/atoms/Typography'
import CardIllustration from 'components/molecules/CardIllustration'
import SectionTitle from 'components/molecules/SectionTitle'
import get from 'lodash.get'
import './Cards.scss'

function Cards(props) {
  const { data } = props
  const title = get(data, 'title')
  const id = get(data, 'id')
  const sectionTitle = get(data, 'sectionTitle')
  const description = get(data, 'description.value')
  const items = get(data, 'items')
  const firstItemRender = get(data, 'first')
  const lastItemRender = get(data, 'last')
  const themeClasses = get(data, 'theme.entity.classes')

  const sliderSettings = {
    dots: true,
    dotsClass: `slick-dots ${props.color ? props.color : 'primary'}`,
    arrows: false,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.2,
          slidesToScroll: 1,
        },
      },
    ],
  }

  return (
    <Container
      id={id}
      fluid="fluid"
      className={`cards ${themeClasses} ${renderIndexItemClass(firstItemRender, lastItemRender)}`}
    >
      <Container>
        {sectionTitle && (
          <Row>
            <Col sm={12} md={8}>
              <SectionTitle title={sectionTitle} className="mt-4" />
            </Col>
          </Row>
        )}
        <Row>
          <Col sm={12} md={12}>
            <ContentBlock>
              {title ? (
                <Typography variant="h2" cssClass="cards-title mb-2 title-bold-md">
                  {title}
                </Typography>
              ) : null}

              <Typography variant="span" component="p" color="gray-100">
                {ReactHtmlParser(description)}
              </Typography>
            </ContentBlock>
          </Col>
        </Row>

        <div className="d-none d-lg-block">
          <Row className="pt-4 pb-3 pb-lg-0">
            {items.map(function (item, index) {
              return (
                <Col md="6" lg="4" key={data.uuid + index}>
                  <CardIllustration
                    header={{
                      url: get(item, 'entity.image.entity.images.large.url'),
                      alt: get(item, 'entity.link.entity.link.title'),
                    }}
                    body={{
                      title: get(item, 'entity.title'),
                      text: get(item, 'entity.description.value'),
                      link: {
                        url: get(item, 'entity.link.entity.link.url.path'),
                        alt: get(item, 'entity.link.entity.link.title'),
                        text: get(item, 'entity.link.entity.link.title'),
                        icon: get(item, 'entity.link.entity.linkType.entity.token'),
                      },
                    }}
                  />
                </Col>
              )
            })}
          </Row>
        </div>

        <div className="d-block d-lg-none">
          <Row className="pt-4">
            <Col sm={12} md={12}>
              <Slider {...sliderSettings}>
                {items.map(function (item, index) {
                  return (
                    <CardIllustration
                      key={index}
                      header={{
                        url: get(item, 'entity.image.entity.images.large.url'),
                        alt: get(item, 'entity.link.entity.link.title'),
                      }}
                      body={{
                        title: get(item, 'entity.title'),
                        text: get(item, 'entity.description.value'),
                        link: {
                          url: get(item, 'entity.link.entity.link.url.path'),
                          alt: get(item, 'entity.link.entity.link.title'),
                          text: get(item, 'entity.link.entity.link.title'),
                        },
                      }}
                    />
                  )
                })}
              </Slider>
            </Col>
          </Row>
        </div>
      </Container>
    </Container>
  )
}

export default Cards
